import React, {Component} from 'react';
import {InputItem, Picker, TextareaItem, Toast,List,Modal} from 'antd-mobile';
import {goodsSiteInfo, goodsAdd, goodsPay} from '../../../service/homeService';
import "./style.less";
import connect from "react-redux/es/connect/connect";
import PayModal from "../../../components/PayModal";
const phoneReg = /^((13)|(14)|(15)|(16)|(17)|(18)|(19))\d{9}$/;
let isSubmit = false;
@connect(
    state => ({userInfo: state.userInfo})
)
export default class GoodsInfo extends Component {
    constructor(props) {
        super(props);
        if (isSubmit) {
            isSubmit = false;
            props.history.goBack();
        }
        this.state = {
            tabIndex:-1,
            typeData:["文件","证照证件","服装鞋帽","数码家电","食品","饮品","鲜花","其它"],
            goodsType:"",
            specifications:"",
            remarks:"",
            userPhone:this.props.userInfo.phone,
            shouPhone:"",
            priceTotal:0,
            tips:false,
            goodsInfo:"",
            payModal:false,
            payData:"",
            formPay:"",
        };
    }
    componentDidMount() {
        let params = {
            source:1,
            token:this.props.userInfo.token,
            data:{
                lineId:this.props.location.state.lineId,
                shiftId:this.props.location.state.shiftId,
            },
        };
        goodsSiteInfo(params).then((res)=>{
            if (res.data.code === '0000') {
                this.setState({goodsInfo:res.data.data});
            }else{
                Toast.info(res.data.msg,3)
            }
        })
    }
    reserveModal(){
        if(this.state.goodsType == ''){
            Toast.info('请选择货物类型');
            return;
        }
        if(this.state.specifications == ''){
            Toast.info('请选择货物规格');
            return;
        }
        if(this.state.userPhone == ''){
            Toast.info('请输入寄件人联系电话');
            return;
        }
        if(this.state.shouPhone == ''){
            Toast.info('请填写收件人联系电话');
            return;
        }
        if (!phoneReg.test(this.state.userPhone.replace(/\s/ig, ''))) {
            Toast.fail('请输入正确的寄件人手机号', 2);
            return;
        }
        if (!phoneReg.test(this.state.shouPhone.replace(/\s/ig, ''))) {
            Toast.fail('请输入正确的收件人手机号', 2);
            return;
        }
        this.setState({tips:true})
    }
    clickType(res,i){
        this.setState({tabIndex:i,goodsType:res});
    }
    goodsSubmit(){
        this.setState({tips:false});
        let params = {
            source:1,
            token:this.props.userInfo.token,
            data:{
                lineId:this.props.location.state.lineId,
                shiftId:this.props.location.state.shiftId,
                senderPhone:this.state.userPhone.replace(/\s/ig, ''),
                recipientsPhone:this.state.shouPhone.replace(/\s/ig, ''),
                logisticsType:this.state.goodsType,
                logisticsWeight:this.state.specifications[0].split("_")[0],
                logisticsPrice:this.state.specifications[0].split("_")[1],
                note:this.state.remarks,
                startCity:this.state.goodsInfo.startCity,
                endCity:this.state.goodsInfo.endCity,
            },
        };
        Toast.loading("",0);
        goodsAdd(params).then((res)=>{
            if (res.data.code === '0000') {
                //调用支付
                this.setState({payModal:true,payData:res.data.data});
                Toast.hide();
            }else{
                Toast.info(res.data.msg,3)
            }
        })
    }
    payType(e){
        if(e == ""){
            Toast.info("请选择支付方式");
            return
        }
        if(e == "工商银行支付"){
            this.weiXinPay(this.state.payData,"icbcjft");
        }
        if(e== "微信支付"){
            this.weiXinPay(this.state.payData,"wx");
        }
    }
    weiXinPay = (orderNo,type) => {
        Toast.loading("",0);
        const params = {
            source: 1,
            token:this.props.userInfo.token,
            data:{
                source: 1,
                orderId: orderNo,
                payChannel:type,
            }
        };
        goodsPay(params).then((res) => {
            if (res.data.code === '0000') {
                Toast.hide();
                if(type == "wx"){
                    this.wxBridgeReady(res.data.data, orderNo);
                }else{
                    isSubmit = true;
                    this.setState({formPay:res.data.data,});
                }
            } else {
                Toast.info(res.data.msg);
            }
        })
    };
    wxBridgeReady = (bridgeInfo, orderNo) => {
        const self = this;

        function onBridgeReady() {
            window.WeixinJSBridge.invoke(
                'getBrandWCPayRequest', {
                    "appId": bridgeInfo.appId,         //公众号名称，由商户传入
                    "timeStamp": bridgeInfo.timeStamp, //时间戳，自1970年以来的秒数
                    "nonceStr": bridgeInfo.nonceStr,   //随机串
                    "package": bridgeInfo.package,     //prepay_id
                    "signType": bridgeInfo.signType,   //微信签名方式
                    "paySign": bridgeInfo.sign         //微信签名
                },
                function (r) {
                    if (r.err_msg === "get_brand_wcpay_request:ok") {
                        Toast.info('支付成功', 2, () => {
                            self.props.history.goBack();
                        });
                    } else if (r.err_msg === "get_brand_wcpay_request:cancel") {
                        isSubmit = true;
                        Toast.info('您取消了支付，可到订单详情支付', 2, () => {
                            self.props.history.push(`/pay/myOrder`,);
                        });
                    } else if (r.err_msg === "get_brand_wcpay_request:fail") {
                        isSubmit = true;
                        Toast.info('支付失败，请稍后重试', 2, () => {
                            self.props.history.push(`/pay/myOrder`,);
                        });
                    }
                }
            );
        }

        if (typeof WeixinJSBridge === "undefined") {
            if (document.addEventListener) {
                document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
            } else if (document.attachEvent) {
                document.attachEvent('WeixinJSBridgeReady', onBridgeReady);
                document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
            }
        } else {
            onBridgeReady();
        }
    };
    payFrom(){
        if(this.state.formPay !== ""){
            return(
                <form
                    name="auto_submit_form"
                    method="post"
                    action={this.state.formPay.url}>
                    <input
                        type="hidden"
                        name="biz_content"
                        value={this.state.formPay.bizContent} />
                    <input type="submit" value="立刻提交" style={{display:"none"}} onClick={setTimeout(()=>document.forms[0].submit(),100)}/>
                </form>
            )
        }else{
            return null
        }
    }
    onClose = (v) => {
        Toast.info('您取消了支付，可到订单详情支付', 2, () => {
            this.props.history.push(`/pay/myOrder`,);
        });
        isSubmit = true;
    };
    render(){
        return(
            <div className="goodsInfo">
                <div className="goBack">
                    <i className="icon iconfont iconfanhui" onClick={() => this.props.history.goBack()} />
                    <span>下单</span>
                </div>
                <div className="warp">
                    <div className="content">
                        <div className="topBar">
                            <div className="city">
                                <span className="start">{this.state.goodsInfo.startCity}</span>
                                <div><span>—</span><div className="carNum">{this.state.goodsInfo.carNum}</div><span>—</span></div>
                                <span className="end">{this.state.goodsInfo.endCity}</span>
                            </div>
                            <div className="time">
                                <span className="">{this.state.goodsInfo.startTime}</span>
                                <span className="">{this.state.goodsInfo.endTime}</span>
                            </div>
                            <p>{this.state.goodsInfo.date}{this.state.goodsInfo.weekend}{this.state.goodsInfo.pickUpTime}准备出发</p>
                        </div>
                        <div className="middle">
                            <div className="select">
                                <div className="title"><i className="icon iconfont iconhuowu"/>请选择货物类型</div>
                                <div className="selectType">
                                    {
                                        this.state.typeData.map((res,i)=>(
                                            <span className={this.state.tabIndex == i ? "click":null} key={i} onClick={()=>this.clickType(res,i)}>{res}</span>
                                        ))
                                    }
                                </div>
                                <div className="title">
                                    <i className="icon iconfont iconchicun"/>
                                    <div className="dateMenu">
                                        <Picker
                                            data={this.state.goodsInfo.weightAndPrices}
                                            cols={1}
                                            title="请选择货物规格"
                                            extra='请选择货物规格'
                                            value={this.state.specifications}
                                            onOk={v => this.setState({ specifications:v,priceTotal:v[0].split("_")[1]})}
                                        >
                                            <List.Item ></List.Item>
                                        </Picker>
                                    </div>
                                    <i className="icon iconfont icontiaozhuan2"/>
                                </div>
                            </div>
                            <div className="remarks">
                                <p>备注信息</p>
                                <TextareaItem
                                    placeholder="请填写物品信息（如：化妆品）或备注说明"
                                    data-seed="logId"
                                    rows={2}
                                    value={this.state.remarks}
                                    onChange={(e)=>this.setState({remarks:e})}
                                />
                            </div>
                            <div className="phone">
                                <div className="jiPhone">
                                    寄件人电话
                                    <InputItem
                                        type="phone"
                                        ref={el => this.inputRef = el}
                                        placeholder="请输入寄件人联系电话"
                                        value={this.state.userPhone}
                                        onChange={(e)=>this.setState({userPhone:e})}
                                    />
                                    {/*<span onClick={() => this.inputRef.focus()}>修改</span>*/}
                                </div>
                                <div className="jiPhone">
                                    收件人电话
                                    <InputItem
                                        type="phone"
                                        ref={el => this.inputRef1 = el}
                                        placeholder="请输入收件人联系电话"
                                        value={this.state.shouPhone}
                                        onChange={(e)=>this.setState({shouPhone:e})}
                                    />
                                    {/*<span onClick={() => this.inputRef1.focus()}>修改</span>*/}
                                </div>
                            </div>
                            <p>*请务必如实填写货物尺寸，若填写尺寸与事实不符司机有权拒单</p>
                            <p>*请保证联系电话正确有效，以免造成不必要的损失！</p>
                        </div>
                    </div>
                </div>

                <div className="footer">
                    <div className="payTotal">合计：
                        <span>￥{parseFloat(this.state.priceTotal).toFixed(2) <= 0 ? 0 : parseFloat(this.state.priceTotal).toFixed(2)}</span>
                    </div>
                    <button className="go" onClick={() => this.reserveModal()}>立即支付</button>
                </div>

                <Modal
                    visible={this.state.tips}
                    className="tipsModal"
                    transparent
                    onClose={()=>this.setState({tips:false})}
                    title="带货说明"
                    footer={[{ text: '知道了', onPress: () => { this.goodsSubmit() }}]}
                >
                    <div className="box">
                        1、物品总重量 <span>不超过30公斤</span>、单件体积长宽高不超过 <span>70厘米x30厘米x50厘米</span>的物品可直接下单； <br/>
                        2、超过30公斤或大体积物品，请联系客服 <span className="kefu">4001389889</span>下单；<br/>
                        3、<span>烟、酒、活物、有异味及违禁品</span>拒绝承运，请勿下单；司机接货时需开箱检查是否属于违禁品；<br/>
                        4、发车 <span>90分钟前</span>退款收取实付金额<span>10%</span>的手续费；<span>90分钟内</span>退款收取实付金额<span>50%</span>的手续费；已过发车时间不予退款；<span>带货订单只能退款，不能改签；</span><br/>
                        5、请提前做好发货准备，如果司机等待取货时间超过 <span>15分钟</span>，司机将 <span>有权拒带</span>货物，和有权直接退款并 <span>收取退款手续费</span>。
                    </div>
                </Modal>
                {this.payFrom()}
                <PayModal
                    modal={this.state.payModal}
                    onClose={this.onClose.bind(this)}
                    payType={this.payType.bind(this)}
                />
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/container/Home/GoodsInfo/index.js